import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';

export const useTrialCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkTrialStatus = async () => {
      const token = sessionStorage.getItem('authToken');
      const userData = sessionStorage.getItem('userData');
      
      if (!token || !userData) {
        navigate('/access-recruit');
        return;
      }

      try {
        const user = JSON.parse(userData);
        const trialEndDate = new Date(user.subscription.trialEndDate);
        const isTrialActive = new Date() < trialEndDate;
        
        // If trial ended and not paid, auto logout
        if (!isTrialActive && user.subscription.paymentStatus !== 'active') {
          sessionStorage.clear();
          navigate('/access-recruit');
          return;
        }

        // Check subscription status from backend
        const response = await axios.get(`${API_BASE_URL}/api/hiring/subscription`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const subscription = response.data.data;
        if (!subscription.isTrialActive && subscription.paymentStatus !== 'active') {
          sessionStorage.clear();
          navigate('/pricing'); // Redirect to pricing page
        }
      } catch (error) {
        console.error('Error checking trial status:', error);
        if (error.response?.data?.code === 'TRIAL_ENDED') {
          sessionStorage.clear();
          navigate('/pricing');
        }
      }
    };

    checkTrialStatus();
    
    // Check every hour
    const interval = setInterval(checkTrialStatus, 60 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, [navigate]);
};